<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
  name: 'App',
  components: {

  },


  created () {
    // tohle nefunguje v consoli: Cannot read property '$store' of undefined
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
          console.log(resolve,reject);
          this.$store.dispatch('logout');
        }
        throw err;
      });
    }),
        this.$store.dispatch('loadDataTexts')
  }
  
  

}
</script>

<style lang="scss">

  @import 'scss/bootstrap/bootstrap';
  @import 'node_modules/bootstrap-vue/src/index.scss';


  h1, h2, h3, h4 {
    font-family: 'Bebas Neue', cursive;
  }

  h2 {

  }

  h3 {
    margin-bottom: 0;
  }

  label {
    font-family: 'Bebas Neue', cursive;
  }

  .font-bebas {
    font-family: 'Bebas Neue', cursive;
  }

  .text-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .badge-danger {
   color: white!important;
  }

  .clickable {
    cursor: pointer;
  }

  .dropdown {
    overflow: hidden;
    &.show {
      overflow: initial;
    }
  }

</style>
